// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  VisualAssetSource,
} from "./types";

export default {
  dtmi: __t.string(),
  assetPath: __t.string(),
  get assetSource() {
    return VisualAssetSource;
  },
  assetModuleAssetId: __t.option(__t.u64()),
};
